import { PersonalDataModel } from "./PersonalData";
import { AppUtils } from '../../utils/index';

/**
 * Basic Model class for Damage PersonalDataModel
 */
export class DamagePersonalDataModel {

	private persoenlicheDaten: PersonalDataModel;
	private kontoinhaber: string;
	private iban: string;
	private bic: string;
	private abweichenderKontoInhaber: boolean;


	constructor(initialProperties?: Partial<DamagePersonalDataModel>) {
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
		this.persoenlicheDaten = new PersonalDataModel();
	}

	public get PersoenlicheDaten(): PersonalDataModel {
		return this.persoenlicheDaten;
	}
	public set PersoenlicheDaten(value: PersonalDataModel) {
		this.persoenlicheDaten = value;
	}

	public get Kontoinhaber(): string {
		return this.kontoinhaber;
	}
	public set Kontoinhaber(value: string) {
		this.kontoinhaber = value;
	}

	public get Iban(): string {
		return this.iban;
	}
	public set Iban(value: string) {
		this.iban = value;
	}

	public get Bic(): string {
		return this.bic;
	}
	public set Bic(value: string) {
		this.bic = value;
	}

	public get AbweichenderKontoInhaber(): boolean {
		return this.abweichenderKontoInhaber;
	}
	public set AbweichenderKontoInhaber(value: boolean) {
		this.abweichenderKontoInhaber = value;
	}



	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): DamagePersonalDataModel {
		return AppUtils.Helper.createFromMap(dataObject, DamagePersonalDataModel, (key: string, value: any) => {
			if (key.toLowerCase() === 'persoenlichedaten') {
				return PersonalDataModel.createFromObject(value);
			}
			return value;
		});
	}
}
